import React, { PureComponent } from "react";

interface SportIconProps {
  name: string;
  style?: any;
  className?: string;
  active?: boolean;
  white?: boolean;
  color?: string;
}

interface SportIconState {}

export class SportIcon extends PureComponent<SportIconProps, SportIconState> {
  constructor(props: any) {
    super(props);
  }

  render() {
    const { name, style, className, active, white, color } = this.props;
    // Prevent SSR mismatch error
    const id1 = name + "1";
    const id2 = name + "2";
    switch (name) {
      case "NFL":
      case "XFL":
        return (
          <svg
            style={style}
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 150 155"
          >
            <defs>
              <clipPath id={id1} transform="translate(5 5)">
                <path
                  d="M101,45.41a4.85,4.85,0,0,0-6.81,0L92.75,46.8l-11-10.88a4.85,4.85,0,0,0-6.81,0,4.7,4.7,0,0,0,0,6.71l11,10.88L73.5,65.79l-11-10.89a4.87,4.87,0,0,0-6.81,0,4.71,4.71,0,0,0,0,6.72l11,10.88L54.25,84.78l-11-10.89a4.85,4.85,0,0,0-6.81,0,4.7,4.7,0,0,0,0,6.71l11,10.89L46,92.88a4.71,4.71,0,0,0,0,6.71,4.85,4.85,0,0,0,6.81,0l1.41-1.39,11,10.88a4.85,4.85,0,0,0,6.81,0,4.7,4.7,0,0,0,0-6.71l-11-10.88L73.5,79.21l11,10.89a4.87,4.87,0,0,0,6.81,0,4.71,4.71,0,0,0,0-6.72l-11-10.88L92.75,60.22l11,10.89a4.85,4.85,0,0,0,6.81,0,4.7,4.7,0,0,0,0-6.71l-11-10.89L101,52.12a4.71,4.71,0,0,0,0-6.71M21.61,142.8c-5.7-1.46-10.15-3.25-13.3-6.4s-4.77-7.88-6.18-13.78a96.16,96.16,0,0,1-2.13-21c0-23,6.54-52.81,26.81-73.88S75.9,0,98.14,0a87.25,87.25,0,0,1,20.25,2.2c5.71,1.46,10.16,3.25,13.31,6.4s4.76,7.88,6.17,13.78a95.55,95.55,0,0,1,2.13,21c0,23-6.54,52.81-26.8,73.88S64.11,145,41.87,145a87.28,87.28,0,0,1-20.26-2.2"
                  style={{ fill: "none", clipRule: "evenodd" }}
                />
              </clipPath>
              <clipPath id={id2} transform="translate(5 5)">
                <rect x="-155" width="991" height="746" style={{ fill: "none" }} />
              </clipPath>
            </defs>
            <title>footballActive</title>
            <g style={{ clipPath: `url(#${id1})` }}>
              <g style={{ clipPath: `url(#${id2})` }}>
                <rect
                  width="150"
                  height="155"
                  style={{
                    fill: color ? color : active ? "#004198" : white ? "#ffffff" : "#5b5e66",
                  }}
                />
              </g>
            </g>
          </svg>
        );
      case "CFB":
        return (
          <svg
            style={style}
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 175 133"
          >
            <defs>
              <clipPath id={id1} transform="translate(5 5)">
                <path
                  d="M165,94.19c.22-1.93-1.48-2.07-3.09-2A8.31,8.31,0,0,0,159,93.62c-.86-2.1-1.7-4.21-2.55-6.31-.29-.72-1.08-3.22-2.1-5.41A7.21,7.21,0,0,0,157.16,80c1.12-1.48.9-3.42-1.17-3.54-3.24-.19-7.51,3-10.42,4.23q-5.9,2.56-12,4.7c-1,.37-7.27,2.4-13.13,4.2a231.49,231.49,0,0,0-20-32.82c.27-.32.54-.64.83-.95,3.76-3.92,9-5.81,13.9-7.89,1.54-.66,16.2-6.12,16.47-5.4-8.14-21.84-23.52-36.21-48-41.2-24.23-4.12-43,2-58.79,13.61C13.2,23.55,5.13,34.21,1.93,48.65-1.45,64-.69,80,6.61,94.06c1.35,2.61,16,27.43,17.62,26.31,6.44-4.4,13.49-8.47,21.49-6.18,5.71,1.63,10.2,5.66,15.77,7.39a31.43,31.43,0,0,0,19.14-.15,28.82,28.82,0,0,0,17.14-14.87,109,109,0,0,0,15,1.45,101.81,101.81,0,0,0,10.61-.28c.39.85.8,1.7,1.24,2.54,2,3.82,5.81,5.94,10,6.91a28.44,28.44,0,0,0,9.37.48,40.37,40.37,0,0,0,11.91-3.43c3.05-1.35,7.62-3,8.39-6.71.64-3.08-2.09-6.54-3.29-9.24-.09-.22-.18-.44-.28-.65,1.72-.72,4.07-1.63,4.27-3.44M61.8,99.42a9.08,9.08,0,1,1,9-9.08,9.07,9.07,0,0,1-9,9.08m38-35.09q2.85,3.9,5.49,8a167.62,167.62,0,0,1,10.85,18.48.25.25,0,0,1,0,.07c-3.69,1.09-6.52,1.82-6.6,1.57-1.79-5.55-6.13-9.85-12-13.39-1.15-5.67-1.73-11.87.14-17.21.76.88,1.54,1.72,2.13,2.52m-.42,37.93c0-.08,0-.15.07-.22,1.57-5.73.94-10.47-.24-15.73a22.71,22.71,0,0,1,3.55,3.45c1.67,2,1.75,7,5,7.28,2.69.19,5.23-.75,7.8-1.4.81-.2,1.62-.42,2.44-.64,1.16,2.77,2.24,5.58,3.39,8.36a91.5,91.5,0,0,1-22.06-1.1m27,.63q-1.85-4.61-3.92-9.12c.47-.14,1-.26,1.42-.41a206.12,206.12,0,0,0,26.13-9.75l.11,0c.32.94.71,1.85,1.05,2.71l3.42,8.6c.09.23.19.46.28.68l-1.37.59c-2.89,1.18-5.84,2.22-8.83,3.11a108.64,108.64,0,0,1-17.4,3.53l-.89.1m24.06,8.7a32,32,0,0,1-11.93,1.58,12.59,12.59,0,0,1-10.1-5.94,101.28,101.28,0,0,0,15.9-3.28A99,99,0,0,0,156.6,99.5c.76,1.71,1.53,3.42,2.25,5.15a3,3,0,0,1,.33,1.38c-.16,2.46-6.78,4.91-8.7,5.56"
                  style={{ fill: "none", clipRule: "evenodd" }}
                />
              </clipPath>
              <clipPath id={id2} transform="translate(5 5)">
                <rect x="-174" y="-170" width="991" height="746" style={{ fill: "none" }} />
              </clipPath>
            </defs>
            <title>ncaaActive</title>
            <g style={{ clipPath: `url(#${id1})` }}>
              <g style={{ clipPath: `url(#${id2})` }}>
                <rect
                  width="175"
                  height="133"
                  style={{
                    fill: color ? color : active ? "#004198" : white ? "#ffffff" : "#5b5e66",
                  }}
                />
              </g>
            </g>
          </svg>
        );
      case "NBA":
        return (
          <svg
            style={style}
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 155 155"
          >
            <defs>
              <clipPath id={id1} transform="translate(5 5)">
                <path
                  d="M123.57,21.11A71.21,71.21,0,0,0,72.5,0c-2.58,0-5.16.16-7.73.32h-.16a72.34,72.34,0,0,0-43.5,21.11A70.9,70.9,0,0,0,.32,66.22C.16,68.15,0,70.41,0,72.5a71.76,71.76,0,0,0,21.11,51.07A71.33,71.33,0,0,0,72.5,145h2.42a72.22,72.22,0,0,0,48.81-21.27,73,73,0,0,0,21.11-47A38.11,38.11,0,0,0,145,72.5a71.87,71.87,0,0,0-21.43-51.39m4.37,58.19A45.22,45.22,0,0,0,95.41,89.42l19.52,19.51c3.55,3.56-2.52,9.63-6.07,6.08L89.2,95.49a46,46,0,0,0-11,32.82c.17,5.15-8.5,5.44-8.68.29A55.2,55.2,0,0,1,83,89.27l-11-11L35.27,114.86c-3.35,3.35-9.42-2.73-6.07-6.07L65.77,72.5,51.32,57.9A53.31,53.31,0,0,1,15.75,71.63c-4.17-.41-3.3-9.09.87-8.67A45.09,45.09,0,0,0,45.25,51.83L29.34,35.92c-2.77-2.7,3.3-8.92,6.07-6.21L51.32,45.47A46.67,46.67,0,0,0,61.44,17c-.42-3.55,8.26-4.57,8.67-1A54.85,54.85,0,0,1,57.39,51.39L72,66.14l36.58-36.87c3.33-3.33,9.55,2.88,6.22,6.22L78.06,72.21,89.2,83.34a54.88,54.88,0,0,1,39.32-12.57c4.44.3,3.86,8.83-.58,8.53"
                  style={{ fill: "none", clipRule: "evenodd" }}
                />
              </clipPath>
              <clipPath id={id2} transform="translate(5 5)">
                <rect x="-505" width="991" height="746" style={{ fill: "none" }} />
              </clipPath>
            </defs>
            <title>basketballActive</title>
            <g style={{ clipPath: `url(#${id1})` }}>
              <g style={{ clipPath: `url(#${id2})` }}>
                <rect
                  width="155"
                  height="155"
                  style={{
                    fill: color ? color : active ? "#004198" : white ? "#ffffff" : "#5b5e66",
                  }}
                />
              </g>
            </g>
          </svg>
        );
      case "ATP":
      case "WTA":
        return (
          <svg
            style={style}
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 15 15"
          >
            <defs>
              <clipPath id={id1}>
                <path
                  style={{ fill: "none", clipRule: "evenodd" }}
                  d="M11.7,7.52A4.86,4.86,0,0,0,13.56,4a3.78,3.78,0,0,0-.72-2.47A3.63,3.63,0,0,0,9,.19,4.82,4.82,0,0,0,6.32,1.74,4.78,4.78,0,0,0,5,4.4c0,.45-.07.91-.1,1.36a2.64,2.64,0,0,1,0,.29,4.42,4.42,0,0,1-.62,2.24.19.19,0,0,0,0,.16l.47.47h0l.43.43c.06.07.11.06.19,0A5.65,5.65,0,0,1,6,9.06a5.8,5.8,0,0,1,1.85-.32h.27c.47,0,.94-.06,1.4-.13A4.48,4.48,0,0,0,11.7,7.52Zm-.9,0a3.64,3.64,0,0,1-2.1.6,3.06,3.06,0,0,1-3-2.19,3.43,3.43,0,0,1,.08-2.28,4.4,4.4,0,0,1,3-2.85,3.3,3.3,0,0,1,2.94.42A2.88,2.88,0,0,1,13,3.41,4.2,4.2,0,0,1,10.8,7.53Zm-7,1.4,1,1a2.39,2.39,0,0,0-.23.22h0l-.51.5-2.5,2.5a.2.2,0,0,0-.08.22.27.27,0,0,1-.09.21.29.29,0,0,1-.24,0c-.32-.3-.64-.61-.94-.94a.28.28,0,0,1,0-.25c0-.05.09-.06.16-.08h0l.08,0,.06,0a.25.25,0,0,0,.13-.05l2.07-2.07c.27-.26.53-.53.8-.81h0Zm8.15-7-.24-.21-.38.43-.42-.42-.05,0,.35-.36m.74.6,0,0Zm0,0-.46.39Zm-.46.39L12,2.8ZM12,2.8l.36-.34Zm.36-.34a.56.56,0,0,0,0,.12Zm0,.12a.37.37,0,0,1,0,.22Zm0,.22a.42.42,0,0,1-.14.17ZM12.28,3Zm0,0-.08.08Zm-.08.08.11.12Zm.11.12Zm0,0,.2.2Zm.2.2a.48.48,0,0,1,0,.71Zm0,.71-.23.22Zm-.23.22Zm0,0-.13.12Zm-.13.12.1.09Zm.1.09Zm0,0Zm0,0,.19.16Zm.19.16a.18.18,0,0,1,.06.25Zm.06.25-.08.18ZM12,4.67l.46.43,0,.05-.07.07L12,5.48a.15.15,0,0,1-.13,0l-.29-.26h0l-.11-.1Zm.44.48,0,0,0,0m0,.05,0,.08Zm0,.08Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0a6.49,6.49,0,0,1-.31.65Zm-.31.65a1.22,1.22,0,0,1-.29.31Zm-.29.31Zm0,0-.16.17Zm-.16.17a.16.16,0,0,0,0,.07Zm0,.07a.11.11,0,0,1,0,.08Zm0,.08,0,0Zm0,0Zm0,0c-.06.08-.13.18-.17.17Zm-.17.17a.16.16,0,0,0-.19.08Zm-.19.08,0,0Zm0,0a2.77,2.77,0,0,1-1.39.84Zm-1.39.84a.22.22,0,0,1-.28-.07ZM9.47,7.6l-.15-.21Zm-.15-.21Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0,0,0Zm0,0-.07,0Zm-.07,0a.94.94,0,0,0-.1.1Zm-.1.1a2.2,2.2,0,0,1-.2.23Zm-.2.23a.53.53,0,0,1-.69,0Zm-.69,0A2.25,2.25,0,0,1,8,7.46ZM8,7.46Zm0,0-.09-.11Zm-.09-.11-.12.1Zm-.12.1Zm0,0Zm0,0a.49.49,0,0,1-.2.14Zm-.2.14c-.06,0-.15,0-.25-.12Zm-.25-.12Zm0,0Zm0,0,0,0Zm0,0,.37-.26Zm.37-.26-.52-.5Zm-.52-.5-.35.47Zm-.35.47-.24-.31Zm-.24-.31L7,6.5ZM7,6.5,6.49,6ZM6.49,6l-.27.35Zm-.27.35-.07,0Zm-.07,0,0-.09Zm0-.09a.43.43,0,0,1,0-.21Zm0-.21c0-.06.07-.11.13-.17Zm.13-.17Zm0,0,.09-.08Zm.09-.08-.1-.1Zm-.1-.1L5.93,5.4ZM5.93,5.4a.5.5,0,0,1,0-.63Zm0-.63a1.89,1.89,0,0,1,.25-.23Zm.25-.23Zm0,0,.15-.14Zm.15-.14-.12-.1Zm-.12-.1Zm0,0A1.37,1.37,0,0,1,6,4.11ZM6,4.11a.18.18,0,0,1,0-.17Zm0-.17s0-.08,0-.13Zm0-.13Zm0,0c.13-.31.26-.62.42-.92Zm.42-.92a.84.84,0,0,1,.23-.23Zm.23-.23Zm0,0,.13-.1Zm.13-.1.12-.12Zm.12-.12.06,0Zm.06,0c-.11-.12,0-.18,0-.24Zm0-.24H7Zm0,0,.11,0Zm.11,0Zm0,0h0Zm.05,0,0,.05Zm0,.05L7.35,2ZM7.35,2l.31-.36Zm.31-.36a.33.33,0,0,1,.14-.1Zm.14-.1.74-.33Zm.74-.33Zm0,0Zm0,0Zm0,0Zm0,0,.19-.08Zm.19-.08A.18.18,0,0,1,9,1.19ZM9,1.19l.16.18Zm.16.18Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0,.1.1Zm.1.1.12-.12Zm.12-.12.27-.28Zm.27-.28a.51.51,0,0,1,.58,0Zm.58,0,.27.28Zm.27.28Zm0,0Zm0,0,.11.12Zm.11.12.1-.09Zm.1-.09Zm0,0a.82.82,0,0,1,.22-.16Zm.22-.16a.35.35,0,0,1,.17.05ZM8.3,3.74l-.42.42-.44-.43.44-.44Zm1.2,2,.4.42.46-.41-.42-.44Zm0-4.11Zm0,0,.42.44.42-.4-.43-.45-.24.24h0C9.62,1.55,9.57,1.61,9.51,1.66Zm.66,4.79.42.41L11,6.45,10.6,6Zm.41-3.17.47.49-.46.39-.46-.44ZM9.23,5.51l.42-.39-.41-.46-.44.43ZM7.21,4l.4.45-.4.42-.44-.46Zm1.55-.69h0L9,3.06,8.94,3h0l-.39-.4L8.14,3l.42.45Zm.89-.91-.41.41L8.8,2.37,9.23,2Zm2.35,1-.43.41.39.41.44-.42ZM8.58,4,9,4.4l-.45.45-.42-.43ZM6.05,5.13l.09.08h0l.31.27a.15.15,0,0,0,.13,0l.3-.27L7,5.12l-.45-.45Zm4.08,0,.48-.47.47.46-.1.09-.32.28a.11.11,0,0,1-.11,0l-.32-.27h0ZM8.82,6.46l.41.42.44-.43L9.24,6ZM7.2,2.61l.42.45-.42.43L6.77,3Zm3.66,1.8.41.42.45-.42L11.29,4ZM10.61,2l.41.43-.41.41-.43-.44ZM9,7.16l-.42-.44-.43.4.42.45Zm2.72-4.1-.42.43-.42-.44.43-.42ZM10.36,7.15l-.43-.44-.42.41.41.44Zm1.36-1.36-.44.42-.42-.43a4,4,0,0,1,.29-.29h0l.14-.13ZM9.93,4,9.5,4.4l.42.44.42-.44Zm-.67.18-.45-.45.43-.44.44.47Zm.25-1.12.42-.44.43.45-.44.45ZM8.31,5.1l-.43-.43-.44.41.45.44ZM6.09,3.71l.43-.41.42.43-.44.41h0C6.37,4,6.23,3.86,6.09,3.71Zm.69,2.05.4.45.45-.43-.42-.44ZM9,5.76l-.45.45-.4-.42.44-.43ZM7.85,6.86,8,6.72H8l.3-.27L7.9,6l-.46.42Zm.71-4.74-.43-.43.44-.44.34.37L9,1.7Zm-1.09.24.39.4.44-.39-.42-.45Z"
                />
                <path
                  style={{ fill: "none", clipRule: "evenodd" }}
                  d="M9.52,12.09a2.64,2.64,0,0,1,2.6-2.6A3,3,0,0,1,9.52,12.09Zm3.29-2.54a2.64,2.64,0,0,1,2,2,3.91,3.91,0,0,0-3.23,3.22,2.56,2.56,0,0,1-2-2A3.87,3.87,0,0,0,12.81,9.55Zm2.09,2.71a2.64,2.64,0,0,1-2.61,2.61A3.1,3.1,0,0,1,14.9,12.26Z"
                />
              </clipPath>

              <clipPath id={id2}>
                <rect x="-7" width="38" height="26" y="-5" style={{ fill: "none" }} />
              </clipPath>
            </defs>
            <title>tennisActive</title>
            <g style={{ clipPath: `url(#${id1})` }}>
              <g style={{ clipPath: `url(#${id2})` }}>
                <rect
                  width="155"
                  height="155"
                  style={{
                    fill: color ? color : active ? "#004198" : white ? "#ffffff" : "#5b5e66",
                  }}
                />
              </g>
            </g>
          </svg>
        );
      case "CBK":
        return (
          <svg
            style={style}
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 132 155"
          >
            <defs>
              <clipPath id={id1} transform="translate(5 5)">
                <path
                  d="M43,53V69.66H53.49V62.87H64.91L50.26,97H63.67L79,60.79V53Zm64.75,74a4.51,4.51,0,0,0,0-9H14.25a4.51,4.51,0,0,0,0,9Zm9.17,18H5.08A4.83,4.83,0,0,1,0,140.47V58.91a4.4,4.4,0,0,1,2.1-3.67C24.77,40.59,20.41,5.41,20.37,5.06a4.25,4.25,0,0,1,1.24-3.54A5.41,5.41,0,0,1,25.42,0H35.58a5,5,0,0,1,5,3.53C42.71,12.13,51.12,18.12,61,18.12s18.29-6,20.46-14.59a5,5,0,0,1,5-3.53H96.58a5.44,5.44,0,0,1,3.81,1.52,4.23,4.23,0,0,1,1.24,3.55c0,.35-4.4,35.53,18.27,50.18a4.37,4.37,0,0,1,2.1,3.66v81.56A4.83,4.83,0,0,1,116.92,145Z"
                  style={{ fill: "none", clipRule: "evenodd" }}
                />
              </clipPath>
              <clipPath id={id2} transform="translate(5 5)">
                <rect x="-196" y="-330" width="991" height="746" style={{ fill: "none" }} />
              </clipPath>
            </defs>
            <title>combinedShapeCopy</title>
            <g style={{ clipPath: `url(#${id1})` }}>
              <g style={{ clipPath: `url(#${id2})` }}>
                <rect
                  width="132"
                  height="155"
                  style={{
                    fill: color ? color : active ? "#004198" : white ? "#ffffff" : "#5b5e66",
                  }}
                />
              </g>
            </g>
          </svg>
        );
      case "MLB":
        return (
          <svg
            style={style}
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 155 155"
          >
            <defs>
              <clipPath id={id1} transform="translate(5 5)">
                <path
                  d="M123.57,21.11A71.21,71.21,0,0,0,72.5,0c-2.58,0-5.16.16-7.73.32h-.16a72.31,72.31,0,0,0-43.5,21.11A70.9,70.9,0,0,0,.32,66.22C.16,68.15,0,70.41,0,72.5a71.76,71.76,0,0,0,21.11,51.07A71.33,71.33,0,0,0,72.5,145h2.42a72.22,72.22,0,0,0,48.81-21.27,73,73,0,0,0,21.11-47A38.11,38.11,0,0,0,145,72.5,71.87,71.87,0,0,0,123.57,21.11ZM51.32,57.9A53.31,53.31,0,0,1,15.75,71.63c-4.17-.41-3.3-9.09.87-8.67A45,45,0,0,0,45.24,51.83l6.08-6.36A46.67,46.67,0,0,0,61.44,17c-.42-3.55,8.26-4.57,8.67-1A54.85,54.85,0,0,1,57.39,51.39ZM93.58,82.22A54.89,54.89,0,0,1,129,69.5c3.56.41,2.55,9.09-1,8.67A46.58,46.58,0,0,0,99.51,88.29l-6.36,6.07A45.07,45.07,0,0,0,82,123c.42,4.17-8.25,5-8.67.87A53.36,53.36,0,0,1,87.08,88.29Z"
                  style={{ fill: "none", clipRule: "evenodd" }}
                />
              </clipPath>
              <clipPath id={id2} transform="translate(5 5)">
                <rect x="-505" y="-180" width="991" height="746" style={{ fill: "none" }} />
              </clipPath>
            </defs>
            <title>baseballActive</title>
            <g style={{ clipPath: `url(#${id1})` }}>
              <g style={{ clipPath: `url(#${id2})` }}>
                <rect
                  width="155"
                  height="155"
                  style={{
                    fill: color ? color : active ? "#004198" : white ? "#ffffff" : "#5b5e66",
                  }}
                />
              </g>
            </g>
          </svg>
        );
      case "GOLF":
        return (
          <svg
            style={style}
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 155 155"
          >
            <defs>
              <clipPath id={id1} transform="translate(5 5)">
                <path
                  d="M104.88,70.81a9.8,9.8,0,1,0-13.86,0,9.8,9.8,0,0,0,13.86,0m-70-5.18a9.8,9.8,0,1,0-13.86,0,9.8,9.8,0,0,0,13.86,0M53,83.77a9.8,9.8,0,1,0-13.86,0,9.8,9.8,0,0,0,13.86,0M80.65,11.42a9.8,9.8,0,1,0,13.86,0,9.81,9.81,0,0,0-13.86,0M72.88,36.21a9.8,9.8,0,1,0,13.85,0,9.8,9.8,0,0,0-13.85,0M65.1,62.14a9.8,9.8,0,1,0,13.86,0,9.8,9.8,0,0,0-13.86,0M98.8,31a9.8,9.8,0,1,0,13.86,0A9.8,9.8,0,0,0,98.8,31m-70-5.19a9.8,9.8,0,1,0,13.86,0,9.8,9.8,0,0,0-13.86,0m25.93-7.78a9.8,9.8,0,1,0,13.85,0,9.8,9.8,0,0,0-13.85,0M47,44a9.8,9.8,0,1,0,13.86,0A9.8,9.8,0,0,0,47,44M145,72.5A72.5,72.5,0,1,1,72.5,0,72.5,72.5,0,0,1,145,72.5"
                  style={{ fill: "none", clipRule: "evenodd" }}
                />
              </clipPath>
              <clipPath id={id2} transform="translate(5 5)">
                <rect x="-505" y="-360" width="991" height="746" style={{ fill: "none" }} />
              </clipPath>
            </defs>
            <title>golfActive</title>
            <g style={{ clipPath: `url(#${id1})` }}>
              <g style={{ clipPath: `url(#${id2})` }}>
                <rect
                  width="155"
                  height="155"
                  style={{
                    fill: color ? color : active ? "#004198" : white ? "#ffffff" : "#5b5e66",
                  }}
                />
              </g>
            </g>
          </svg>
        );
      case "EPL":
      case "DEB":
      case "MLS":
      case "ESP":
      case "ITSA":
      case "UCL":
      case "WC":
        return (
          <svg
            style={style}
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 155 155"
          >
            <defs>
              <clipPath id={id1} transform="translate(5 5)">
                <path
                  d="M72.5,0A72.5,72.5,0,1,0,145,72.5,72.5,72.5,0,0,0,72.5,0Zm3.09,26.68L94,13.34c14.75,5.44,26.06,13.88,32.14,26.88l-7.89,19.4-19.8,4.65-23-16.37ZM50.12,12.94l18.6,13.74.4,21-23,17L25.47,59.42l-7.68-19C25.27,27.45,36.22,18.48,50.12,12.94ZM24.25,114.19A58.33,58.33,0,0,1,9.5,77.81L24.25,65.28l20.42,5L53,96,41.63,114Zm67.71,19a70.17,70.17,0,0,1-39.41.41l-6.06-16L57.8,100.25H86.5l11.32,17.18Zm28.5-19-17.18-.4L91.35,96l8.49-25.46,19.81-5.06L135.21,78C135,91,129.93,103.06,120.46,114.19Z"
                  style={{ fill: "none", clipRule: "evenodd" }}
                />
              </clipPath>
              <clipPath id={id2} transform="translate(5 5)">
                <rect x="-505" y="-540" width="991" height="746" style={{ fill: "none" }} />
              </clipPath>
            </defs>
            <title>soccerActive</title>
            <g style={{ clipPath: `url(#${id1})` }}>
              <g style={{ clipPath: `url(#${id2})` }}>
                <rect
                  width="155"
                  height="155"
                  style={{
                    fill: color ? color : active ? "#004198" : white ? "#ffffff" : "#5b5e66",
                  }}
                />
              </g>
            </g>
          </svg>
        );
      case "NHL":
        return (
          <svg
            style={style}
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 145 150"
          >
            <defs>
              <clipPath id={id1} transform="translate(5 5)">
                <path
                  d="M132.44,13.76,99.59.31a4.26,4.26,0,0,0-3.18,0,4,4,0,0,0-2.25,2.16L54.72,96.52H4.15A4.24,4.24,0,0,0,0,100.75V135.9A4.13,4.13,0,0,0,4.15,140h77.1a4.16,4.16,0,0,0,3.84-2.53L134.68,19.12A4.09,4.09,0,0,0,132.44,13.76Zm-123,118H27.67V104.73H9.41Zm26.55,0H54.5V104.73H36Z"
                  style={{ fill: "none", clipRule: "evenodd" }}
                />
              </clipPath>
              <clipPath id={id2} transform="translate(5 5)">
                <rect x="-850" width="991" height="746" style={{ fill: "none" }} />
              </clipPath>
            </defs>
            <title>nhlActive</title>
            <g style={{ clipPath: `url(#${id1})` }}>
              <g style={{ clipPath: `url(#${id2})` }}>
                <rect
                  width="145"
                  height="150"
                  style={{
                    fill: color ? color : active ? "#004198" : white ? "#ffffff" : "#5b5e66",
                  }}
                />
              </g>
            </g>
          </svg>
        );
      default:
        return null;
    }
  }
}
